import React from 'react';

const Icon = ({ size = '50', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...other}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.41602 10.8333C9.41602 9.68274 10.3488 8.75 11.4993 8.75H40.666C41.8166 8.75 42.7493 9.68274 42.7493 10.8333V40C42.7493 41.1506 41.8166 42.0833 40.666 42.0833H11.4993C10.3488 42.0833 9.41602 41.1506 9.41602 40V10.8333Z"
                stroke="white"
                stroke-width="1.875"
            />
            <path
                d="M16.8308 19.576C19.4068 19.576 20.7028 21.704 20.7028 25.4C20.7028 29.08 19.3748 31.224 16.8308 31.224C14.2868 31.224 12.9588 29.096 12.9588 25.4C12.9588 21.72 14.2708 19.576 16.8308 19.576ZM14.7828 25.4C14.7828 28.328 15.4868 29.704 16.8308 29.704C18.1908 29.704 18.8788 28.344 18.8788 25.4C18.8788 22.472 18.1588 21.096 16.8148 21.096C15.4708 21.096 14.7828 22.552 14.7828 25.4ZM22.3774 28.84H24.6014V31H22.3774V28.84ZM26.2866 19.8H33.9506V21.32C31.4386 24.12 30.0626 27.208 29.7746 30.984V31H27.7746C28.0306 27.608 29.6466 24.2 32.0946 21.432H26.2866V19.8Z"
                fill="white"
            />
            <path
                d="M36.4966 24.5625C37.9878 24.5625 38.9819 25.2414 39.1153 26.4901H37.6726C37.5635 25.9203 37.1513 25.6536 36.3997 25.6536C35.7207 25.6536 35.2601 25.8839 35.2601 26.2961C35.2601 26.7326 35.6359 26.975 36.8482 27.2054C38.7758 27.557 39.3214 28.1631 39.3214 29.133C39.3214 30.4423 38.1212 31.1697 36.5209 31.1697C34.8721 31.1697 33.781 30.4302 33.7446 28.9875H35.1267C35.2116 29.727 35.6844 30.0786 36.5451 30.0786C37.3938 30.0786 37.9393 29.8362 37.9393 29.2906C37.9393 28.8542 37.6605 28.5268 35.9147 28.2237C34.8721 28.0419 33.878 27.5812 33.878 26.3567C33.878 25.1808 35.0297 24.5625 36.4966 24.5625Z"
                fill="white"
            />
        </svg>
    );
};
export default React.memo(Icon);
